import { render, staticRenderFns } from "./DialogScartaCalciatori.vue?vue&type=template&id=c912f32e&scoped=true&"
import script from "./DialogScartaCalciatori.vue?vue&type=script&lang=js&"
export * from "./DialogScartaCalciatori.vue?vue&type=script&lang=js&"
import style0 from "./DialogScartaCalciatori.vue?vue&type=style&index=0&id=c912f32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c912f32e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c912f32e')) {
      api.createRecord('c912f32e', component.options)
    } else {
      api.reload('c912f32e', component.options)
    }
    module.hot.accept("./DialogScartaCalciatori.vue?vue&type=template&id=c912f32e&scoped=true&", function () {
      api.rerender('c912f32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogScartaCalciatori.vue"
export default component.exports